<template>
  <div id ="app" class="t_container">
    <div class="container">
      <!-- banner -->
      <div class="banner">
        <img v-if="isMoPhone" src="../assets/imgs/bannerImg_mobile.jpg" alt="">
        <img v-else src="../assets/imgs/bannerImg.png" alt="">
      </div>
      <!-- <div class="backClass" @click="goBack">返回主页面 <span>https://www.wch.cn</span> </div> -->
      <!-- 头部 -->
      <!-- <div class="header">
        <div class="headerText">
            更适于电机应用的青稞RISC-V内核搭配自研高压功率技术，芯片内置高压LDO，双N、N+P预驱，融合Type-C PD等专业接口技术，多协议聚合。CH32M等全栈MCU，提供更优化的引脚布局与资源配置，外围精简，成本更省；完善的调试工具和专业免费IDE MRS，开发周期更短。
        </div>
      </div> -->

      <!-- 电机应用产品概览 -->
      <div class="application">
          <div class="moduleTitle">
            <div class="text">电机应用产品概览</div>
            <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
          </div>
          <!-- 电机MCU产品概览 -->
          <div class="mcuOverview">
            <div class="secondTitle">电机MCU</div>
            <div class="content">
              <img style="width:100%; height:100%;" src="../assets/imgs/mcu.png" alt="">
              <a class="unit unit_641" href="https://www.wch.cn/products/CH641.html" target="_blank" title="CH641"></a>
              <a class="unit unit_32X035" href="https://www.wch.cn/products/CH32X035.html" target="_blank" title="CH32X035"></a>
              <a class="unit unit_32V007" href="https://www.wch.cn/products/CH32V007.html" target="_blank" title="CH32V007"></a>
              <a class="unit unit_32M007G" href="https://www.wch.cn/products/CH32M007.html" target="_blank" title="CH32M007G"></a>
              <a class="unit unit_32M007E" href="https://www.wch.cn/products/CH32M007.html" target="_blank" title="CH32M007E"></a>
              <a class="unit unit_32M030"  href="https://www.wch.cn/products/CH32M030.html" target="_blank" title="CH32M030"></a>
              <a class="unit unit_32L103"  href="https://www.wch.cn/products/CH32L103.html" target="_blank" title="CH32L103"></a>
              <a class="unit unit_32M103E" title="CH32M103E"></a>
              <a class="unit unit_32V203"  href="https://www.wch.cn/products/CH32V203.html" target="_blank" title="CH32V203"></a>
            </div>
          </div>
          <!-- 独立预驱芯片 -->
          <div class="chipOverview">
            <div class="secondTitle">独立预驱芯片</div>
            <div class="content">
              <el-row :gutter="10" class="rowClass">
                <el-col  :xs="24" :sm="24" :md="24" :lg="7" :xl="7" class="colClass">
                  <div class="left">
                    <div class="title">需求打包，一步到位</div>
                    <div class="text">基于自研高压功率技术，不但在MCU中集成预驱，还提供内置LDO的独立预驱芯片，方案组合更灵活，设计验证更高效，成本更省。 </div>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="17" :xl="17" class="colClass">
                  <div class="right">
                    <el-row :gutter="10" class="rowClass">
                      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="colClass">
                        <div class="chipItem" >
                          <div class="title"><span class="verticalLine"></span>CH282</div>
                          <div class="text">带LDO的24V三相P+N管栅极驱动芯片</div>
                        </div>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="colClass">
                        <div class="chipItem" style="cursor:pointer;" @click="clickChipItem('CH283')">
                          <div class="title"><span class="verticalLine"></span>CH283</div>
                          <div class="text">带LDO的48V三相双N管栅极驱动芯片</div>
                        </div>
                      </el-col>
                      <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="colClass">
                        <div class="chipItem" id="chipItem3">
                          <div class="title"><span class="verticalLine"></span>CH280</div>
                          <div class="text">300V单半桥双N管栅极驱动芯片</div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
      </div>

      <!-- 产品优势 -->
      <div class="advantage">
          <div class="moduleTitle" id="adv_moduleTitle">
              <div class="text">产品优势</div>
              <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
          </div>
          <div class="content">
              <img src="../assets/imgs/advantage.png" alt="">
          </div>
      </div>

      <!-- 产品选型 -->
      <div class="selectModel">
          <div class="moduleTitle" >
              <div class="text">产品选型</div>
              <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
          </div>
          <div class="content">
              <div class="tableClass">
                <el-table
                  :data="tableData"
                  :span-method="objectSpanMethod"
                  border
                  style="width: 100%; margin-top: 20px"
                >
                  <el-table-column :fixed="true" prop="chipName" label="型号" align="center" width="120">
                    <template slot-scope="scope">
                      <a v-if="scope.row.url" style="color:#0071d5" :href="scope.row.url" target="_blank">{{scope.row.chipName}}</a>
                      <span v-else style="color:#0071d5">{{scope.row.chipName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="产品特性" align="center" width="240">
                    <el-table-column prop="LDO" align="center" width="70"><template slot="header">高压<br/>LDO</template></el-table-column>
                    <el-table-column prop="preDrive" label="预驱动" align="center" width="70">
                      <template slot-scope="scope">
                        <span v-html="scope.row.preDrive"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="typeC"  align="center" width="70"><template slot="header">Type-C<br/>PD</template>
                      <template slot-scope="scope">
                        <span v-html="scope.row.typeC"></span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column label="适用方案" align="center" width="140">
                    <el-table-column prop="BLDC" label="BLDC" align="center" width="80">
                      <template slot-scope="scope">
                        <span v-html="scope.row['BLDC']"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="PMSM" label="PMSM" align="center" width="80">
                      <template slot-scope="scope">
                        <span v-html="scope.row['PMSM']"></span>
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column prop="apply" label="适用产品" align="center" width="120">
                    <template slot-scope="scope">
                      <span v-html="scope.row.apply"></span>
                    </template>
                  </el-table-column>
                  <el-table-column label="内核" align="center" width="70">
                    <el-table-column prop="RISC" align="center" width="70"><template slot="header">青稞<br/>RISC-V</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="存储" align="center" width="130">
                    <el-table-column prop="FLASH"  align="center" width="70"><template slot="header">FLASH<br/>（KB）</template></el-table-column>
                    <el-table-column prop="RAM"  align="center" width="60"><template slot="header">RAM<br/>（KB）</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="算力" align="center" width="215">
                    <el-table-column prop="frequency"  align="center" width="75"><template slot="header" >主频<br/>（MHz）</template></el-table-column>
                    <el-table-column prop="multip" align="center" width="70"><template slot="header">单周期<br/>乘法</template>
                      <template slot-scope="scope">
                        <span v-html="scope.row.multip"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="division"  align="center" width="70"><template slot="header">硬件<br/>除法</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="模拟资源" align="center" width="530">
                    <el-table-column prop="amplofier" label="运放" align="center" width="100">
                      <template slot-scope="scope">
                        <span v-html="scope.row.amplofier"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="comparer" label="比较器" align="center" width="100">
                      <template slot-scope="scope">
                        <span v-html="scope.row.comparer"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="ADC" label="ADC" align="center" width="80">
                      <template slot-scope="scope">
                        <span v-html="scope.row['ADC']"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="DAC" label="DAC" align="center" width="70"></el-table-column>
                    <el-table-column prop="protect" align="center" width="90"><template slot="header">过压/过温<br/>保护</template></el-table-column>
                    <el-table-column prop="electric" align="center" width="90"><template slot="header">可编程灌<br/>电流模块</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="物理特性" align="center" width="200">
                    <el-table-column prop="valtage" label="工作电压" align="center" width="110">
                      <template slot-scope="scope">
                        <span v-html="scope.row.valtage"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="temperature" align="center" width="90"><template slot="header">工作温度<br/>范围</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="定时器" align="center" width="210">
                    <el-table-column prop="advancedTimer" label="高级定时器" align="center" width="110">
                      <template slot-scope="scope">
                        <span v-html="scope.row.advancedTimer"></span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="systemTimer" align="center" width="100"><template slot="header">通用/精简/<br/>系统定时器</template></el-table-column>
                  </el-table-column>
                  <el-table-column label="通讯资源" align="center" width="220">
                    <el-table-column prop="USB" label="USB" align="center" width="70"></el-table-column>
                    <el-table-column prop="UART" align="center" width="80"><template slot="header">UART/<br/>ISP/SPI</template></el-table-column>
                    <el-table-column prop="CAN" label="CAN" align="center" width="70"></el-table-column>
                  </el-table-column>
                  <el-table-column label="其他" align="center" width="190">
                    <el-table-column prop="TKey" label="TKey" align="center" width="70"></el-table-column>
                    <el-table-column prop="package" label="封装" align="center" width="120">
                      <template slot-scope="scope">
                        <span  v-html="scope.row.package"></span>
                      </template>
                    </el-table-column>
                    </el-table-column>
                 
                </el-table>
              </div>
              <div class="tips">
                  <span>注：低速 < 60000ERPM </span>
                  <span>中速 < 120000ERPM </span>
                  <span>高速 < 200000ERPM </span>
              </div>
          </div>
      </div>
      <!-- 典型应用 -->
      <div class="typicalApp">
          <div class="moduleTitle" >
            <div class="text">典型应用</div>
            <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
          </div>
          <div class="content">
            <el-row :gutter="10" class="rowClass">
              <el-col  :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="colClass">
                <div class="BLDC">
                  <div class="bldc_head">
                    <div class="title">BLDC</div>
                    <div class="tabs">
                      <div class="tabItem">
                        <div class="bldc_tabName bldc_tabName1" @click="clickBldcTab(0)">HALL</div>
                        <div class="bldc_arrow bldc_arrow1"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                      <div class="tabItem">
                        <div class="bldc_tabName bldc_tabName2" @click="clickBldcTab(1)">ADC</div>
                        <div class="bldc_arrow bldc_arrow2"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                      <div class="tabItem">
                        <div class="bldc_tabName bldc_tabName3" @click="clickBldcTab(2)">CMP</div>
                        <div class="bldc_arrow bldc_arrow3"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                    </div>
                  </div>
                  <div class="bldc_content" >
                    <!-- <img class="bldcImg bldcImg1"  src="../assets/imgs/bldc_hall.png" alt="">
                    <img class="bldcImg bldcImg2" src="../assets/imgs/bldc_adc.png" alt="">
                    <img class="bldcImg bldcImg3" src="../assets/imgs/bldc_cmp.png" alt=""> -->
                    <el-carousel class="bldc_carousel bldc_carousel1" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="bldcImg bldcImg1"  src="../assets/imgs/bldc_hall.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="bldcImg bldcImg1"  src="../assets/imgs/bldc_hall2.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/bldc_hall.png" alt="">
                    </el-carousel>
                    <el-carousel class="bldc_carousel bldc_carousel2" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="bldcImg bldcImg2"  src="../assets/imgs/bldc_adc.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="bldcImg bldcImg2"  src="../assets/imgs/bldc_adc2.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/bldc_adc.png" alt="">
                    </el-carousel>
                    <el-carousel class="bldc_carousel bldc_carousel3" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="bldcImg bldcImg3"  src="../assets/imgs/bldc_cmp.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="bldcImg bldcImg3"  src="../assets/imgs/bldc_cmp2.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/bldc_cmp.png" alt="">
                    </el-carousel>
                    
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="colClass">
                <div class="PMSM">
                  <div class="pmsm_head">
                    <div class="title">PMSM</div>
                    <div class="tabs">
                      <div class="tabItem">
                        <div class="pmsm_tabName pmsm_tabName1" @click="clickPmsmTab(0)">单电阻无感</div>
                        <div class="pmsm_arrow pmsm_arrow1"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                      <div class="tabItem">
                        <div class="pmsm_tabName pmsm_tabName2" @click="clickPmsmTab(1)">双电阻无感</div>
                        <div class="pmsm_arrow pmsm_arrow2"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                      <div class="tabItem">
                        <div class="pmsm_tabName pmsm_tabName3" @click="clickPmsmTab(2)">双电阻编码器</div>
                        <div class="pmsm_arrow pmsm_arrow3"><img src="../assets/imgs/arrow.png" alt=""></div>
                      </div>
                    </div>
                  </div>
                  <div class="pmsm_content" >
                    <!-- <img class="pmsmImg pmsmImg1" src="../assets/imgs/pmsm1.png" alt="">
                    <img class="pmsmImg pmsmImg2" src="../assets/imgs/pmsm2.png" alt="">
                    <img class="pmsmImg pmsmImg3" src="../assets/imgs/pmsm3.png" alt=""> -->
                    <el-carousel class="pmsm_carousel pmsm_carousel1" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="pmsmImg pmsmImg1"  src="../assets/imgs/pmsm1.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="pmsmImg pmsmImg1"  src="../assets/imgs/pmsm1_.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/pmsm1.png" alt="">
                    </el-carousel>
                    <el-carousel class="pmsm_carousel pmsm_carousel2" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="pmsmImg pmsmImg2"  src="../assets/imgs/pmsm2.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="pmsmImg pmsmImg2"  src="../assets/imgs/pmsm2_.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/pmsm2.png" alt="">
                    </el-carousel>
                    <el-carousel class="pmsm_carousel pmsm_carousel3" :interval="5000"  arrow="always" :initial-index='0'>
                      <el-carousel-item><img  class="pmsmImg pmsmImg3"  src="../assets/imgs/pmsm3.png" alt=""> </el-carousel-item>
                      <el-carousel-item><img  class="pmsmImg pmsmImg3"  src="../assets/imgs/pmsm3_.png" alt=""> </el-carousel-item>
                      <img style="width:100%;opacity:0;" src="../assets/imgs/pmsm3.png" alt="">
                    </el-carousel>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
      </div>

      <!-- 应用框图 -->
      <div class="appBorderImg">
        <div class="moduleTitle  borderModuleTitle" >
          <div class="text">应用框图</div>
          <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
        </div>
        <div class="border_content">
          <div class="brief">
            <div>支持BLDC/PMSM、有感/无感、单/双电阻等多种控制方案</div>
            <div>提供模块化、标幺化、定制化电机算法库，性能更优越</div>
          </div>
          <img class="appborderImage" src="../assets/imgs/appborderImage.png" alt="">
        </div>
      </div>

      <!-- 配套工具 -->
      <div class="tool">
        <div class="moduleTitle" >
          <div class="text">配套工具</div>
          <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
        </div>
        <div class="tool_content">
          <img src="../assets/imgs/toolImg.png" alt="">
        </div>
      </div>

      <!-- 应用场景 -->
      <div class="scene">
        <div class="moduleTitle" >
          <div class="text">应用场景</div>
          <img class="titleLine" src="../assets/imgs/oneTitleLine.png" alt="">
        </div>
        <div class="scene_content">
          <el-row :gutter="10" class="rowClass">
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem1 col">
                <img class="sceneImg" src="../assets/imgs/scene1.png" alt="">
              </div>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem2 col" style="cursor:pointer;" @click="clickSceneItem('https://www.wch.cn/application/724.html')">
                <img class="sceneImg" src="../assets/imgs/scene2.png" alt="">
              </div>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem3 col" style="cursor:pointer;" @click="clickSceneItem('https://www.wch.cn/application/722.html')">
                <img class="sceneImg" src="../assets/imgs/scene3.png" alt="">
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem4 col" style="cursor:pointer;" @click="clickSceneItem('https://www.wch.cn/application/723.html')">
                <img class="sceneImg" src="../assets/imgs/scene4.png" alt="">
              </div>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem5 col" style="cursor:pointer;" @click="clickSceneItem('https://www.wch.cn/application/577.html')">
                <img class="sceneImg" src="../assets/imgs/scene5.png" alt="">
              </div>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem6 col" style="cursor:pointer;" @click="clickSceneItem('https://www.wch.cn/application/597.html')">
                <img class="sceneImg" src="../assets/imgs/scene6.png" alt="">
              </div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem7 col">
                <img class="sceneImg" src="../assets/imgs/scene7.png" alt="">
              </div>
            </el-col>
            <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="sceneCol">
              <div class="sceneItem8 col">
                <img  class="sceneImg" src="../assets/imgs/scene8.png" alt="">
              </div>
            </el-col>
          </el-row>

        </div>
      </div>

    </div>
  </div>
</template>
 
<script>

  export default {
    name:'home',
    data() {
      return{
        windowWidth: window.innerWidth,
        isMoPhone:false,
        tableData:[
          { 
            chipName:'CH641',
            url:'https://www.wch.cn/products/CH641.html',
            LDO:'√',
            preDrive:'PN<br/>（12V）',
            typeC:'√',
            BLDC:'无感低速<br/>低压可充电',
            PMSM:'-',
            apply:'小循环泵<br/>手持小风扇<br/>简易按摩器<br/>简易电动工具',
            RISC:'V2A',
            FLASH:'16',
            RAM:'2',
            frequency:'48M',
            multip:'-',
            division:'-',
            amplofier:'1<br/><span class="note">固定大增益</span>',
            comparer:'-',
            ADC:'10bit<br/>800ksps',
            DAC:'-',
            protect:true,
            electric:'-',
            valtage:'4.0~12.6V',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'1/-/1',
            USB:'-',
            UART:'1/1/-',
            CAN:'-',
            TKey:'-',
            package:'QFN28<br/>QFN20'
          },
          { 
            chipName:'CH32V007',
            url:'',
            LDO:'-',
            preDrive:'-',
            typeC:'-',
            BLDC:'有感/无感<br/>中速',
            PMSM:'有感/无感<br/>低速',
            apply:'水泵<br/>风扇<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V2C',
            FLASH:'62',
            RAM:'8',
            frequency:'48M',
            multip:'√',
            division:'-',
            amplofier:'1<br/><span class="note">通道可切换<br/>增益可配置</span>',
            comparer:'1<br/><span class="note">通道可切换</span><br/>1精简<br/><span class="note">输入OPA<br/>输出刹车</span>',
            ADC:'12bit<br/>3.0Msps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'2.5～5V',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'1/1/1',
            USB:'-',
            UART:'2/1/1',
            CAN:'-',
            TKey:'8路',
            package:'QFN32<br/>QSOP24'
          },
          { 
            chipName:'CH32M007',
            url:'',
            LDO:'√',
            preDrive:'双N<br/>PN',
            typeC:'-',
            BLDC:'无感<br/>中速',
            PMSM:'有感/无感<br/>低速',
            apply:'水泵<br/>风扇<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V2C',
            FLASH:'62',
            RAM:'8',
            frequency:'48M',
            multip:'√',
            division:'-',
            amplofier:'1<br/><span class="note">通道可切换<br/>增益可配置</span>',
            comparer:'1<br/><span class="note">通道可切换</span><br/>1精简<br/><span class="note">输入OPA<br/>输出刹车</span>',
            ADC:'12bit<br/>3.0Msps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'G：6-48V<br/><span class="note">集成双N预驱</span><br/>E：6-24V<br/><span class="note">集成PN预驱</span>',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'1/1/1',
            USB:'-',
            UART:'2/1/1',
            CAN:'-',
            TKey:'7路',
            package:'QFN26C3(PN)<br/>QSOP24(PN)<br/>QSOP28(NN)'
          },
          { 
            chipName:'CH32X035',
            url:'https://www.wch.cn/products/CH32X035.html',
            LDO:'-',
            preDrive:'-',
            typeC:'√<br/>PDUSB',
            BLDC:'有感/无感<br/>中速',
            PMSM:'有感/无感<br/>低速',
            apply:'水泵<br/>风扇<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V4C',
            FLASH:'62',
            RAM:'20',
            frequency:'48M',
            multip:'√',
            division:'√',
            amplofier:'2<br/><span class="note">通道可切换<br/>增益可配置</span>',
            comparer:'3',
            ADC:'12bit<br/>470ksps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'2.5~5.5V',
            temperature:'-40～85℃',
            advancedTimer:'2',
            systemTimer:'1/-/1',
            USB:'1',
            UART:'4/1/1',
            CAN:'-',
            TKey:'14路',
            package:'LQFP64M<br/>LQFP48<br/>QFN28<br/>QSOP28'
          },
          { 
            chipName:'CH32M030',
            url:'',
            LDO:'√',
            preDrive:'双N,4路互补2个高压引脚',
            typeC:'√<br/>PDUSB',
            BLDC:'有感<br/>中速',
            PMSM:'有感/无感<br/>中速',
            apply:'洗衣机<br/>压缩机<br/>滑板车<br/>高速风筒<br/>高速吸尘器<br/>电动自行车<br/>水泵<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V3B',
            FLASH:'64',
            RAM:'12',
            frequency:'72M',
            multip:'√<br/><span class="note">32位定标乘法单周期完成</span>',
            division:'-',
            amplofier:'4<br/><span class="note">2个可配置为差分输入<br/>2个单端输入增益可配置</span>',
            comparer:'3<br/><span class="note">2个正负端输入可灵活配置<br/>1个简易比较器输入端和运放输出关联</span>',
            ADC:'12bit<br/>1.0Msps',
            DAC:'6bit',
            protect:'√',
            electric:'√',
            valtage:'5-28V<br/><span class="note">集成双N预驱</span>',
            temperature:'-40～105℃',
            advancedTimer:'1<br/><span class="note">非对称PWM<br/>BLDC便捷配置</span>',
            systemTimer:'1/1/1',
            USB:'1',
            UART:'1/1/1',
            CAN:'-',
            TKey:'-',
            package:'QSOP28(NN)<br/>QFN32(NN)'
          },
          { 
            chipName:'CH32L103',
            url:'https://www.wch.cn/products/CH32L103.html',
            LDO:'-',
            preDrive:'-',
            typeC:'√<br/>PDUSB',
            BLDC:'有感/无感<br/>高速',
            PMSM:'有感/无感<br/>中速',
            apply:'洗衣机<br/>压缩机<br/>滑板车<br/>高速风筒<br/>高速吸尘器<br/>电动自行车<br/>水泵<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V4C',
            FLASH:'64',
            RAM:'20',
            frequency:'96M',
            multip:'√',
            division:'√',
            amplofier:'1<br/><span class="note">通道可切换<br/>增益可配置</span>',
            comparer:'3',
            ADC:'12bit<br/>2.4Msps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'1.8~3.6V',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'3/1/1',
            USB:'1',
            UART:'4/2/2',
            CAN:'1',
            TKey:'10路',
            package:'LQFP48<br/>QFN32<br/>QSOP28<br/>QFN20'
          },
          { 
            chipName:'CH32M103',
            url:'',
            LDO:'√',
            preDrive:'PN',
            typeC:'√<br/>PDUSB',
            BLDC:'有感/无感<br/>高速',
            PMSM:'有感/无感<br/>中速',
            apply:'洗衣机<br/>压缩机<br/>滑板车<br/>高速风筒<br/>高速吸尘器<br/>电动自行车<br/>水泵<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V4C',
            FLASH:'64',
            RAM:'20',
            frequency:'96M',
            multip:'√',
            division:'√',
            amplofier:'1<br/><span class="note">通道可切换<br/>增益可配置</span>',
            comparer:'3',
            ADC:'12bit<br/>2.4Msps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'1.8~3.6V',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'3/1/1',
            USB:'1',
            UART:'4/2/2',
            CAN:'1',
            TKey:'10路',
            package:'QSOP28(PN)'
          },
          { 
            chipName:'CH32V203',
            url:'https://www.wch.cn/products/CH32V203.html',
            LDO:'-',
            preDrive:'-',
            typeC:'-',
            BLDC:'有感/无感<br/>高速',
            PMSM:'有感/无感<br/>高速',
            apply:'洗衣机<br/>压缩机<br/>滑板车<br/>高速风筒<br/>高速吸尘器<br/>电动自行车<br/>水泵<br/>飞控<br/>筋膜枪<br/>榨汁机<br/>破壁机<br/>电动工具<br/>电动小车<br/>空气净化器<br/>高速吹草机',
            RISC:'V4C',
            FLASH:'64',
            RAM:'20',
            frequency:'144M',
            multip:'√',
            division:'√',
            amplofier:'2',
            comparer:'',
            ADC:'12bit<br/>1.0Msps',
            DAC:'-',
            protect:'-',
            electric:'-',
            valtage:'2.4~3.6V',
            temperature:'-40～85℃',
            advancedTimer:'1',
            systemTimer:'4/0/1',
            USB:'2',
            UART:'4/2/2',
            CAN:'1',
            TKey:'16路',
            package:'LQFP64M<br/>LQFP48<br/>QFN48X7<br/>QSOP28<br/>TSSOP20'
          },
          
        ],
      }
    },
    computed: {

    },
    created() {
      window.addEventListener('resize', this.handleResize)
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    watch: {
      windowWidth(newWidth, oldWidth) {
        if (newWidth <= 900) {
          this.isMoPhone = true
        }else{
          this.isMoPhone = false
        }
      }
    },
    activated(){
    },
    mounted(){
      if (this.windowWidth <= 900) {
        this.isMoPhone = true
      }else{
        this.isMoPhone = false
      }
      console.log('isMoPhone---',this.isMoPhone)
      this.clickBldcTab(0)
      this.clickPmsmTab(0)
   
    },
    methods:{
      handleResize() {
        this.windowWidth = window.innerWidth
      },
      // goBack(){
      //   window.location.href = 'https://www.wch.cn'
      // },
      clickChipItem(chip){
        window.open(`https://www.wch.cn/products/${chip}.html`)
      },
      clickSceneItem(link){
        window.open(link)
      },
      //点击BLDC切换
      clickBldcTab(num){
        for(let i = 0; i<document.getElementsByClassName("bldc_tabName").length; i++){
          document.getElementsByClassName("bldc_tabName")[i].style.color="#fff";
          document.getElementsByClassName("bldc_tabName")[i].style.backgroundColor="transparent";
          document.getElementsByClassName("bldc_tabName")[i].style.fontWeight="500";
          document.getElementsByClassName("bldc_carousel")[i].style.display="none";
          // document.getElementsByClassName("bldcImg")[i].style.display="none";
          document.getElementsByClassName("bldc_arrow")[i].style.display="none";
        }
        document.getElementsByClassName("bldc_tabName")[num].style.color="#1651ff";
        document.getElementsByClassName("bldc_tabName")[num].style.backgroundColor="#fff";
        document.getElementsByClassName("bldc_tabName")[num].style.fontWeight="600";
        document.getElementsByClassName("bldc_carousel")[num].style.display="block";
        // document.getElementsByClassName("bldcImg")[num].style.display="block";
        document.getElementsByClassName("bldc_arrow")[num].style.display="block";
      },
      //点击PMSM切换
      clickPmsmTab(num){
        for(let i = 0; i<document.getElementsByClassName("pmsm_tabName").length; i++){
          document.getElementsByClassName("pmsm_tabName")[i].style.color="#fff";
          document.getElementsByClassName("pmsm_tabName")[i].style.backgroundColor="transparent";
          document.getElementsByClassName("pmsm_tabName")[i].style.fontWeight="500";
          document.getElementsByClassName("pmsm_carousel")[i].style.display="none";
          // document.getElementsByClassName("pmsmImg")[i].style.display="none";
          document.getElementsByClassName("pmsm_arrow")[i].style.display="none";
        }
        document.getElementsByClassName("pmsm_tabName")[num].style.color="#333";
        document.getElementsByClassName("pmsm_tabName")[num].style.backgroundColor="#fff";
        document.getElementsByClassName("pmsm_tabName")[num].style.fontWeight="600";
        document.getElementsByClassName("pmsm_carousel")[num].style.display="block";
        // document.getElementsByClassName("pmsmImg")[num].style.display="block";
        document.getElementsByClassName("pmsm_arrow")[num].style.display="block";
      },

      //合并行
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // if(columnIndex==6 ){
          // console.log('row',row)
          // console.log('column',column)
          // console.log('rowIndex',rowIndex)
          // console.log('columnIndex',columnIndex)
        //   if(rowIndex==1){
        //     return {
        //       rowspan: 3,
        //       colspan: 1
        //     };
        //   }else if(rowIndex==2||rowIndex==3||rowIndex==5||rowIndex==6||rowIndex==7){
        //     return {
        //       rowspan: 0,
        //       colspan: 1
        //     };
        //   }else if(rowIndex==4){
        //     return {
        //       rowspan: 4,
        //       colspan: 1
        //     };
        //   }else{
        //     return {
        //       rowspan: 1,
        //       colspan: 1
        //     };
        //   }
        // }


        //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
          const fields = ['apply']
          // 当前行的数据
          const cellValue = row[column.property]
          // 判断只合并定义字段的列数据
          if (cellValue && fields.includes(column.property)) {
            const prevRow = this.tableData[rowIndex - 1] //上一行数据
            let nextRow = this.tableData[rowIndex + 1] //下一行数据
            // 当上一行的数据等于当前行数据时，当前行单元格隐藏
            if (prevRow && prevRow[column.property] === cellValue) {
              return { rowspan: 0, colspan: 0 }
            } else {
              // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
              let countRowspan = 1 //用于合并计数多少单元格
              while (nextRow && nextRow[column.property] === cellValue) {
                nextRow = this.tableData[++countRowspan + rowIndex] //更新下一行
              }
              if (countRowspan > 1) {
                return { rowspan: countRowspan, colspan: 1 }
              }
            }
          }
      },
    }
  };
</script>
  
<style lang='less' scoped>
  .t_container {
    width: 100%;
    margin: 0;
    font-family: Microsoft YaHei, Arial, Helvetica, sans-serif !important;
    text-align: left;
  }
    .container{
       width: 100%;
       height: 100%;
       background-color: white;
    }
    .banner{
      width: 100%;
    }
    .banner img{
      width: 100%;
    }
    .backClass{
        color: #1b98fd;
        border: 1px solid #1b98fd;
        padding: 5px 8px;
        position: absolute;
        right: 3%;
        font-size: 14px;
        cursor: pointer;
    }
    /* 头部 */
    .header{
        width: 100%;
        height: 360px;
        padding-top: 80px;
        box-sizing: border-box;
        background: url('../assets/imgs/headerBg1.png') no-repeat;
        background-size: 100%;
        // margin-top: -0.5%;
    }
    .headerText{
        font-size: 20px;
        /* z-index: 2; */
        color: #000;
        width: 55%;
        margin-left: 10%;
        line-height: 46px;
    }
    /* 电机应用产品概览 */
    .application{
        width: 80%;
        margin: 0 auto;
        margin-top: 50px;
    }
    .moduleTitle .text{
        font-size: 32px;
        font-weight: 600;
        color: #333;
        text-align: center;
        margin-bottom: 15px;
        letter-spacing: 3px;
    }
    .moduleTitle .titleLine{
        width: 100%;
    }
    .mcuOverview{
        margin-top: 20px;
    }
    .secondTitle{
        width: 215px;
        height: 52px;
        background: url('../assets/imgs/secondTtileBg.png') no-repeat;
        background-size: contain;
        font-size: 24px;
        line-height: 50px;
        color: #fff;
        text-align: center;
    }
    .mcuOverview .content{
        margin-top: 40px;
        position: relative;
        width: 90%;
        margin: 0 auto;
    }
    .unit{
        position: absolute;
        width: 12.9%;
        height: 8.8%;
        border-radius: 5px;
        /* background: #e3e3e3; */
    }
    .unit:hover{
        box-shadow: 7px 5px 10px rgba(46, 46, 46,0.4),0 0 10px rgba(0, 0, 0,0) inset;
        border: transparent;
        width: 12.7%;
        height: 8.6%;
        transition: all .25s;
    }
    .unit_641{
        top: 54.2%;
        left: 9.5%;
    }
    .unit_32X035{
        top: 10%;
        left: 27.5%;
    }
    .unit_32V007{
        top: 29.7%;
        left: 27.5%;
    }
    .unit_32M007G{
        top: 40%;
        left: 27.5%;
    }
    .unit_32M007E{
        top: 49.9%;
        left: 27.5%;
    }
    .unit_32M030{
        top: 10%;
        left: 45.4%;
    }
    .unit_32L103{
        top: 10%;
        left: 63.4%;
    }
    .unit_32L103{
        top: 10%;
        left: 63.4%;
    }
    .unit_32L103{
        top: 10%;
        left: 63.4%;
    }
    .unit_32M103E{
        top: 20.4%;
        left: 63.4%;
    }
    .unit_32V203{
        top: 3.2%;
        left: 81.2%;
    }
    
    .chipOverview{
        margin-top: 20px;
    }
    .chipOverview .content{
        margin-top: 40px;
        display: flex;
        justify-content: space-evenly;
        // padding-left: 2%;
    }
    .chipOverview .content .left {
        padding-right: 25px;
        margin-top: -15px;
    }
    .chipOverview .content .left .title{
        font-size: 24px;
        color: #1651ff;
        font-weight: 600;
    }
    .chipOverview .content .left .text{
        font-size: 18px;
        line-height: 28px;
        color: #333;
        margin-top: 10px;
    }
    .rowClass{
        padding: 0px !important;
        margin: 0px !important;
        width: 100%;
    }
    .colClass{
        padding: 0px !important;
        margin: 0px !important;
    }
    .chipOverview .content .right .chipItem{
        padding: 15px;
        padding-bottom: 25px;
        /* height: 90px; */
        /* word-wrap: break-word; */
        margin: 0px 10px;
        /* margin-bottom: 10px; */
        word-break: break-word;
        background-color: #e5f0ff;
        color: #333;
        // cursor: pointer;
    }
    .chipOverview .content .right .chipItem .verticalLine{
        display: inline-block;
        width: 4px;
        height: 20px;
        margin-right: 12px;
        background-color: #1651ff;
    }
    .chipOverview .content .right .chipItem .title{
        font-size: 24px;
        font-weight: 600;
    }
    .chipOverview .content .right .chipItem .text{
        font-size: 16px;
        line-height: 24px;
        margin-top: 15px;
    }
    #chipItem3{
        margin-right: 0px;
    }
    /* 产品优势 */
    .advantage{
        margin-top: 90px;
        width: 100%;
    }
    #adv_moduleTitle{
        width: 80%;
        margin: 0 auto;
    }
    .advantage .content{
        width: 100%;
    }
    .advantage .content img{
        width: 100%;
    }
    /* 产品选型 */
    .selectModel{
        width: 80%;
        margin: 0 auto;
        margin-top: 90px;
    }
    .tableClass /deep/.el-table thead.is-group th.el-table__cell{
        // background: #81aadd;
        // color: #000;
        font-weight: 600;
        background: #4f78b4;
        color: #fff;
    }
    .tableClass ::v-deep.el-table td.el-table__cell, ::v-deep.el-table th.el-table__cell.is-leaf{
        // border-bottom: 1px solid #b1b1b1; 
        border-bottom: 1px solid #dcdcdc; 
    }
    .tableClass /deep/.el-table{
      // border-right:  1px solid #b1b1b1;
      border-right:  2px solid #dcdcdc;
    }
    .tableClass /deep/.el-table thead tr th{
      // border: 1px solid #767676;
      border: 2px solid #e1e1e1;
      border-bottom: none;
      border-right: none;
    }
    .tableClass /deep/.el-table .el-table__body td,
    .tableClass /deep/.el-table .el-table__body th{
      // border-left: 1px solid #b1b1b1;
      border-left: 1px solid #dcdcdc;
    }
    .tableClass /deep/.el-table--border, .el-table--group{
      border:none;
      border-right: 1px solid #dcdcdc;
    }
    .tableClass /deep/.el-table .el-table__cell{
      padding: 4px 0px;
    }
    .tableClass /deep/.el-table .cell{
      padding: 0px 4px;
      line-height: 16px;
    }
    .tableClass /deep/.el-table .note{
      color: #b7b7b7;
    }
    
    .tips{
        color: #9b9b9b;
        font-size: 14px;
        margin-top: 20px;
    }
    .tips span{
        margin-right:20px;
    }
    /* 典型应用 */
    .typicalApp{
        width: 80%;
        margin: 0 auto;
        margin-top: 90px;
    }
    .typicalApp .content{
        margin-top: 20px;
    }
    .BLDC{
        margin-right: 10px;
        border: 1px solid #d5d5d5;
        border-radius: 8px;
    }
    .BLDC .bldc_head{
        background: url('../assets/imgs/BLDC_bg.png') no-repeat;
        background-size: cover;
        height: 140px;
        padding: 15px 40px;
        box-sizing: border-box;
    }
    .BLDC .bldc_head .title{
        color: #fff;
        font-size: 24px;
        font-weight: 600;
    }
    .BLDC .bldc_head .tabs{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .BLDC .bldc_head .tabs .tabItem{
       position: relative;
    }
    .BLDC .tabItem .bldc_tabName{
        // width: 100px;
        width: 160px;
        background-color: transparent;
        border: 1px solid #fff;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        font-size: 18px;
        line-height: 32px;
        cursor: pointer;
    }
    .bldc_content{
      padding: 12px;
    }
    .BLDC .bldc_carousel{
      width: 100%;
    }
    .typicalApp .content /deep/.el-carousel__arrow{
      width: 40px;
      height: 40px;
      font-size: 20px;
      background: rgba(34, 34, 34,0.15);
    }
    .typicalApp .content /deep/.el-carousel__arrow:hover{
      background: rgba(34, 34, 34,0.35);
    }
    .typicalApp .content /deep/.el-carousel__container{
      // height: 500px;
      height: auto;
    }
    .BLDC .bldc_carousel1{
       display: block;
    }
    .BLDC .bldc_carousel2{
       display: block;
    }
    .BLDC .bldc_carousel3{
       display: none;
    }
    // .bldcImg1{
    //     display: block;
    // }
    // .bldcImg2{
    //     display: none;
    // }
    // .bldcImg3{
    //     display: none;
    // }
    .BLDC .bldc_arrow{
        position: absolute;
        bottom: -130%;
        left: 40%;
    }
    .BLDC .bldc_arrow1{
        display: block;
    }
    .BLDC .bldc_arrow2{
        display: none;
    }
    .BLDC .bldc_arrow3{
        display: none;
    }
    .BLDC .bldc_content .bldcImg{
        width: 100%;
    }
    .PMSM{
        margin-left: 10px;
        border: 1px solid #d5d5d5;
        border-radius: 8px;
    }
    .PMSM .pmsm_head{
        background: url('../assets/imgs/PMSM_bg.png') no-repeat;
        background-size: cover;
        height: 140px;
        padding: 15px 40px;
        box-sizing: border-box;
    }
    .PMSM .pmsm_head .title{
        color: #fff;
        font-size: 24px;
        font-weight: 600;
    }
    .PMSM .pmsm_head .tabs{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    .PMSM .pmsm_head .tabs .tabItem{
       position: relative;
    }
    .PMSM .tabItem .pmsm_tabName{
        // width: 130px;
        width: 160px;
        background-color: transparent;
        border: 1px solid #fff;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        font-size: 18px;
        line-height: 32px;
        cursor: pointer;
    }
    .pmsm_content{
      padding: 12px;
    }
    // .pmsmImg1{
    //     display: block;
    // }
    // .pmsmImg2{
    //     display: none;
    // }
    // .pmsmImg3{
    //     display: none;
    // }
    .PMSM .pmsm_carousel{
      width: 100%;
    }
    .PMSM .pmsm_carousel1{
       display: block;
    }
    .PMSM .pmsm_carousel2{
       display: block;
    }
    .PMSM .pmsm_carousel3{
       display: none;
    }
    .PMSM .pmsm_arrow{
        position: absolute;
        bottom: -130%;
        left: 42%;
    }
    .PMSM .pmsm_arrow1{
        display: block;
    }
    .PMSM .pmsm_arrow2{
        display: none;
    }
    .PMSM .pmsm_arrow3{
        display: none;
    }
    .PMSM .pmsm_content .pmsmImg{
        width: 100%;
    }

    /* 应用框图 */
    .appBorderImg{
        width:100% ;
        margin-top: 90px;
    }
    .borderModuleTitle{
        width: 80%;
        margin: 0 auto;
    }
    .appBorderImg .border_content{
        margin-top: 20px;
    }
    .appBorderImg .border_content .brief{
        width: 45%;
        height: 75px;
        padding-top: 6px;
        box-sizing: border-box;
        margin: 0 auto;
        background: url('../assets/imgs/brief.png') no-repeat;
        background-size: 100% 100%;
        text-align: center;
        font-size: 22px;
        color: #fff;
        margin-bottom: 20px;
    }
    .appBorderImg .border_content .appborderImage{
        width: 100%;
    }

    /* 配套工具 */
    .tool{
        width: 80%;
        margin: 0 auto;
        margin-top: 90px;
    }
    .tool_content{
        margin-top: 20px;
        border-radius: 5px;
        // border: 1px solid #ccc;
        box-shadow: 1px 1px 10px 3px #D3D3D6;
        padding: 40px;
    }
    .tool_content img{
        width: 100%;
    }
    
    /* 应用场景 */
    .scene{
        width: 80%;
        margin: 0 auto;
        margin-top: 90px;
        margin-bottom: 50px;
    }
    .scene_content{
        margin-top: 20px;
    }
    .scene_content .sceneCol{
        padding: 10px !important;
    }
    /* .sceneCol .col{
       cursor: pointer;
       transition: all 0.2s;
    }
    .sceneCol .col:hover{
      transform: scale(1.05);
    } */
    .sceneImg{
        width: 100%;
    }



   
    
  // 兼容分辨率----------------------------------------
    @media screen and (min-width: 2000px){
      .mcuOverview .content{
        width: 85%;
      }
    }
    @media screen and (max-width: 1750px){
      .chipOverview .content .right .chipItem .text{
        line-height: 20px;
        height: 32px;
      }
      .mcuOverview .content{
        width: 100%;
      }
        
    }
    @media screen and (max-width: 1600px){
      .header{
        padding-top: 60px;
      }
      .headerText{
        width: 65%;
        line-height: 42px;
      }
      .chipOverview .content .left {
        padding-right: 5px;
      }
      .chipOverview .content .left .text{
        font-size: 17px;
        line-height: 26px;
      }
      .chipOverview .content .right .chipItem .text{
        font-size: 14px;
      }
      .chipOverview .content .right .chipItem .title{
        font-size: 22px;
      }
      .appBorderImg .border_content .brief{
        font-size: 20px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 130px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 130px;
      }
    }
    @media screen and (max-width: 1400px){
      .header{
        padding-top: 50px;
        height: 300px;
      }
      .headerText{
        width: 75%;
      }
      .moduleTitle .text{
        font-size: 32px;
      }
      .chipOverview .content .left .text{
        font-size: 16px;
        line-height: 22px;
      }
      .secondTitle{
        font-size: 22px;
        width: 190px;
        line-height: 46px;
      }
      .BLDC .bldc_head{
        height: 130px;
      }
      .BLDC .bldc_head .tabs{
        margin-top: 10px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 105px;
        font-size: 16px;
      }
      .BLDC .bldc_arrow{
        left: 37%;
      }
      .PMSM .pmsm_head{
        height: 130px;
      }
      .PMSM .pmsm_head .tabs{
        margin-top: 10px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 105px;
        font-size: 16px;
      }
      .PMSM .pmsm_arrow{
        left: 37%;
      }
      .appBorderImg .border_content .brief{
        width: 50%;
        font-size: 18px;
      }
    }
    @media screen and (max-width: 1199px) {
      .header{
        padding-top: 30px;
        height: 280px;
      }
      .headerText{
        line-height: 36px;
        font-size: 18px;
      }
      .chipOverview .content .left {
        padding-right: 0px;
      }
      .chipOverview .content .left .text{
        margin-bottom: 10px;
        font-size: 18px;
        line-height: 28px;
        padding-right: 0px;
      }
      .chipOverview .content .right .chipItem{
        margin: 10px 0px;
        margin-top: 0px;
        padding: 10px 15px;
      }
      .chipOverview .content .right .chipItem .text{
        font-size: 16px;
        line-height: 22px;
        height: auto;
        margin-top: 5px;
      }
      .BLDC{
        margin-right: 0px;
      }
      .PMSM{
        margin-left: 0px;
        margin-top: 60px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 130px;
        font-size: 18px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 130px;
        font-size: 18px;
      }
      .appBorderImg .border_content .brief{
        width: 54%;
        font-size: 16px;
        padding-top: 8px;
      }
    }
    @media screen and (max-width: 1050px) {
      .header{
        padding-top: 30px;
        height: 260px;
      }
      .headerText{
        width: 80%;
        line-height: 32px;
        font-size: 16px;
      }
      .application{
        margin-top: 20px;
      }
      .appBorderImg .border_content .brief{
        width: 58%;
        font-size: 15px;
      }
      
    }
    @media screen and (max-width: 800px) {
      .moduleTitle .text{
        font-size: 28px;
        margin-bottom: 0px;
      }
      .secondTitle{
        font-size: 20px;
      }
      .BLDC .bldc_head{
        padding: 18px 30px;
      }
      .BLDC .bldc_head .title{
        font-size: 22px;
      }
      .PMSM .pmsm_head{
        padding: 18px 30px;
      }
      .PMSM .pmsm_head .title{
        font-size: 22px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 105px;
        font-size: 15px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 105px;
        font-size: 15px;
      }
      .appBorderImg .border_content .brief{
        width: 65%;
        font-size: 13px;
        padding-top: 15px;
      }
      .mcuOverview .content{
        margin-top: 20px;
      }
      .chipOverview  .content{
        margin-top: 20px;
      }
    }
    @media screen  and (max-width: 630px) {
      .headerText{
        font-size: 15px;
        line-height: 24px;
      }
      .moduleTitle .text{
        font-size: 24px;
      }
      .chipOverview .content .left .title{
        font-size: 17px;
      }
      .chipOverview .content .left .text{
        font-size: 15px;
        line-height: 22px;
      }
      .chipOverview .content .right .chipItem .title{
        font-size: 17px;
      }
      .chipOverview .content .right .chipItem .text{
        font-size: 15px;
        line-height: 22px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 90px;
        font-size: 13px;
      }
      .BLDC .bldc_head {
        padding: 10px 20px;
        height: 122px;
      }
      .BLDC .bldc_head .title{
        font-size: 20px;
      }
      .BLDC .bldc_arrow{
        bottom: -136%;
        left: 35%;
      }
      .PMSM{
        margin-top: 30px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 90px;
        font-size: 13px;
      }
      .PMSM .pmsm_head {
        padding: 10px 20px;
        height: 122px;
      }
      .PMSM .pmsm_head .title{
        font-size: 20px;
      }
      .PMSM .pmsm_arrow{
        bottom: -136%;
        left: 35%;
      }
      .typicalApp .content /deep/.el-carousel__arrow{
        width: 30px;
        height: 30px;
        font-size: 16px;
      }
      .appBorderImg .border_content .brief{
        width: 70%;
        font-size: 12px;
      }
      .mcuOverview .content{
        margin-top: 5px;
      }
      .chipOverview  .content{
        margin-top: 5px;
      }
      .advantage{
        margin-top: 60px;
      }
      .selectModel{
        margin-top: 60px;
      }
      .typicalApp{
        margin-top: 60px;
      }
      .tool{
        margin-top: 60px;
      }
      .scene{
        margin-top: 60px;
      }
    }
    @media screen  and (max-width: 500px) {
      .application{
        margin-top: 10px;
      }
      .BLDC .tabItem .bldc_tabName{
        width: 80px;
        font-size: 10px;
      }
      .BLDC .bldc_head {
        padding: 10px 10px;
        height: 120px;
      }
      .PMSM .tabItem .pmsm_tabName{
        width: 80px;
        font-size: 10px;
      }
      .PMSM .pmsm_head {
        padding: 10px 10px;
        height: 120px;
      }
      .appBorderImg .border_content .brief{
        width: 92%;
        height: 50px;
        background-size: 100% 100%;
        padding-top: 6px;
      }
      .typicalApp .content /deep/.el-carousel__arrow{
        width: 24px;
        height: 24px;
        font-size: 14px;
      }
      .typicalApp .content /deep/.el-carousel__arrow--right{
        right: 4px;
      }
      .typicalApp .content /deep/.el-carousel__arrow--left{
        left: 4px;
      }
    }
    @media screen  and (max-width: 420px) {
      .secondTitle{
        font-size: 18px;
        width: 170px;
        line-height: 38px
      }
    }

  </style>


